import type { FC } from 'react';
import React from 'react';
import { IntlProvider } from 'react-intl';
import { translations } from '../utils/i18n';

const LanguageProvider: FC<{ children: React.ReactNode }> = ({ children }) => (
  <IntlProvider locale="en" messages={translations['en']}>
    {children}
  </IntlProvider>
);
export { LanguageProvider };
